import { chatStore } from 'state/store';

export const selectMessages = () => {
    return chatStore.getMessages;
};

export const selectIsScrolled = (): boolean => {
    return chatStore.getIsScrolled;
};

export const selectMessageInput = (): string => {
    return chatStore.getMessageInput;
};

export const selectHasNewMessage = (): boolean => {
    return chatStore.getHasNewMessage;
};

export const selectNewMessageCount = (): number => {
    return chatStore.getNewMessageCount;
};
